import {
  Dialog,
  DialogContent,
  DialogActions,
  Typography,
} from "@mui/material";
import { DialogHeader } from "../../auth/components/DialogHeader";
import BaseButton from "./BaseButton";
import DangerBaseButton from "./DangerBaseButton";

export function RopCancelRegisterModal(props: {
  open: boolean;
  setOpen: (open: boolean) => void;
  onCancel: () => void;
  modalText: string;
}) {
  const { open, setOpen, modalText } = props;
  const onClose = () => setOpen(false);
  const onCancel = () => {
    onClose();
    props.onCancel();
  };
  return (
    <Dialog
      onClose={onClose}
      aria-labelledby="customized-dialog-title"
      open={open}
    >
      <DialogHeader id="customized-dialog-title" onClose={onClose}>
        Cancelar Cadastro
      </DialogHeader>
      <DialogContent
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          width: "450px",
          height: "110px",
        }}
        dividers
      >
        <Typography gutterBottom>{modalText}</Typography>
      </DialogContent>
      <DialogActions>
        <DangerBaseButton title="Cancelar Cadastro" onClick={onCancel} />
        <BaseButton
          sx={{ width: "fit-content" }}
          title="Fechar"
          onClick={onClose}
        />
      </DialogActions>
    </Dialog>
  );
}
